/**
 * Logos de las compañías, en `public/logos/`.
 *
 * Son los logos corporativos originales «TeamSystem | nombre», salvo el de TS
 * Facturas. Con la misma altura se ven del mismo tamaño, menos el de TS
 * Facturas, que lleva aire arriba y abajo y necesita más. Una compañía sin logo
 * aquí (o cuyo fichero falte) se pinta con el icono de TeamSystem y su nombre.
 */
export interface LogoDeCompania {
  fichero: string;
  /** Altura de la imagen, para igualar el tamaño aparente entre logos. */
  alto: string;
}

const ALTO_ESTANDAR = '1.6rem';

export const LOGOS: Record<string, LogoDeCompania> = {
  SDELSOL: { fichero: 'sdelsol.svg', alto: ALTO_ESTANDAR },
  AIG: { fichero: 'aig.png', alto: ALTO_ESTANDAR },
  APLIFISA: { fichero: 'aplifisa.svg', alto: ALTO_ESTANDAR },
  DISTRITOK: { fichero: 'distritok.svg', alto: ALTO_ESTANDAR },
  GOLDENSOFT: { fichero: 'goldensoft.svg', alto: ALTO_ESTANDAR },
  QUIPU: { fichero: 'quipu.png', alto: ALTO_ESTANDAR },
  TSFACTURAS: { fichero: 'tsfacturas.webp', alto: '2.3rem' },
};

/**
 * Iconos de los productos de Software Delsol, en `public/productos/`, por el
 * código del servicio. Un servicio sin icono (o cuyo fichero falte) conserva el
 * icono genérico.
 */
export const ICONOS_PRODUCTO: Record<string, string> = {
  CONTASOL: 'contasol.svg',
  CRMSOL: 'crmsol.svg',
  DELSOL: 'delsol.svg',
  FACTUSOL: 'factusol.svg',
  GDE: 'gde.svg',
  NOMINASOL: 'nominasol.svg',
  REVISO: 'reviso.svg',
  TPVSOL: 'tpvsol.svg',
};
